import { Interval } from 'app/agriculture/AgTimeline/types';
import { ChartInterval } from 'app/agriculture/hooks/useAggregateChartData/useAggregateChartData';
import { add, endOfDay, endOfHour, endOfMonth, sub } from 'date-fns';

enum DashboardViewModeEnum {
    Day,
    Week,
    Month,
    Year,
}

export interface DashboardViewConfig {
    label: string;
    intervalUnit: ChartInterval;
    getNewInterval: (date: Date) => Interval<Date>;
    tableDateFormat: string;
    chartDateFormat: string;
    dateTableHeader: string;
    tableTitle: string;
}

export const dashboardViewModeConfig = {
    Day: {
        label: 'Day',
        dateTableHeader: 'Hour',
        tableTitle: 'Hourly',
        intervalUnit: 'hour',
        getNewInterval: (date) => ({
            start: endOfHour(sub(date, { hours: 24 })),
            end: endOfHour(date),
        }),
        chartDateFormat: 'haaa',
        tableDateFormat: 'haaa',
    },
    Week: {
        label: 'Week',
        dateTableHeader: 'Day',
        tableTitle: 'Daily',
        intervalUnit: 'day',
        getNewInterval: (date) => ({
            start: endOfDay(sub(date, { days: 6 })),
            end: endOfDay(date),
        }),
        chartDateFormat: 'EEE',
        tableDateFormat: 'EEE',
    },
    Month: {
        label: 'Month',
        dateTableHeader: 'Day',
        tableTitle: 'Daily',
        intervalUnit: 'day',
        getNewInterval: (date) => ({
            start: endOfDay(add(sub(date, { months: 1 }), { days: 1 })),
            end: endOfDay(date),
        }),
        chartDateFormat: 'd LLL',
        tableDateFormat: 'dd/MM/yy',
    },
    Year: {
        label: 'Year',
        dateTableHeader: 'Month',
        tableTitle: 'Monthly',
        intervalUnit: 'month',
        getNewInterval: (date) => ({
            start: endOfMonth(sub(date, { months: 11 })),
            end: endOfMonth(date),
        }),
        chartDateFormat: 'LLL yy',
        tableDateFormat: 'LLL yyyy',
    },
} as const satisfies { [key in keyof typeof DashboardViewModeEnum]: DashboardViewConfig };

export type DashboardViewMode = keyof typeof dashboardViewModeConfig;
